import { AddCircleIcon, Button } from "@jutro/ui";
import { EmptySearchListVector } from "assets/EmptySearchListVector";

type Props = {
  searchInputValue: string;
  onSearchInputValueReset: () => void;
} & (
  | { mode: "scheduleCreator"; onModalOpen: () => void }
  | { mode: "attendanceTracker" }
);

export const EmptyDoctorsList = ({
  searchInputValue,
  onSearchInputValueReset,
  ...props
}: Props) => {
  const handleInputValueChange = () => {
    onSearchInputValueReset();
  };

  return (
    <div className="bg-jutro-new-warm-gray-50/50 flex h-full flex-col items-center justify-center gap-8 rounded-2xl">
      <EmptySearchListVector />

      {searchInputValue ? (
        <>
          <div className="flex flex-col items-center gap-2">
            <span className="font-heading-3">
              Wpisana fraza - {searchInputValue} - nie pasuje do żadnej z osób w
              naszej bazie
            </span>

            <span className="font-paragraph-0">
              Sprawdź, czy imię i nazwisko zostały poprawnie napisane lub
              spróbuj wpisać tylko nazwisko.
            </span>
          </div>
          <Button
            text="Wyczyść wyszukiwanie"
            full={false}
            variant="secondary"
            onClick={handleInputValueChange}
          />
        </>
      ) : (
        <>
          {props.mode === "scheduleCreator" ? (
            <>
              <span className="font-paragraph-0">
                W wybranej lokalizacji nie utworzono jeszcze żadnej zmiany
              </span>
              <Button
                text="Utwórz zmianę"
                variant="secondary"
                icon={<AddCircleIcon />}
                full={false}
                onClick={() => props.onModalOpen()}
              />
            </>
          ) : (
            <span className="font-paragraph-0">Brak osób do wyświetlenia</span>
          )}
        </>
      )}
    </div>
  );
};
